/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent } from '@vue/composition-api';
import Panel from './components/Panel.js';
import props from './props.js';
import { useCascaderContext } from './hooks.js';
import './components/Item.js';
import '../_chunks/dep-115a1bd3.js';
import 'tdesign-icons-vue';
import './core/helper.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/isEmpty';
import './core/className.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../checkbox/index.js';
import '../checkbox/group.js';
import 'lodash/intersection';
import '../checkbox/checkbox.js';
import 'vue';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../checkbox/props.js';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../utils/event.js';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../checkbox/checkbox-group-props.js';
import '../utils/map-props.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../checkbox/type.js';
import '../loading/index.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../loading/type.js';
import '../loading/plugin.js';
import '../config.js';
import '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../hooks/useGlobalIcon.js';
import '../utils/ripple.js';
import '../hooks/tnode.js';
import 'lodash/isFunction';
import '../hooks/render-tnode.js';
import 'lodash/isObject';
import './core/effect.js';
import 'lodash/isNumber';
import 'lodash/cloneDeep';
import 'lodash/isEqual';
import '../_common/js/tree/tree-store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import 'lodash/difference';
import 'lodash/isPlainObject';
import '../_common/js/tree/tree-node.js';
import '@babel/runtime/helpers/asyncToGenerator';
import '@babel/runtime/regenerator';
import 'lodash/uniqueId';
import 'lodash/isNil';
import 'lodash/get';
import '../_common/js/tree/tree-node-model.js';
import 'lodash/pick';
import 'lodash/omit';
import '../_common/js/log/log.js';
import '../hooks/useVModel.js';
import '../hooks/useDefaultValue.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _CascaderPanel = defineComponent({
  name: "TCascaderPanel",
  props: _objectSpread({}, props),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots,
        emit = _ref.emit;

    var _useCascaderContext = useCascaderContext(props2),
        cascaderContext = _useCascaderContext.cascaderContext;

    var onClick = function onClick(value, node) {
      emit("click", value, node);
    };

    return {
      cascaderContext: cascaderContext,
      slots: slots,
      onClick: onClick
    };
  },
  render: function render() {
    var h = arguments[0];
    return h(Panel, {
      "attrs": {
        "empty": this.empty,
        "trigger": this.trigger,
        "cascaderContext": this.cascaderContext
      },
      "scopedSlots": {
        empty: this.slots.empty
      },
      "on": {
        "click": this.onClick
      }
    });
  }
});

export { _CascaderPanel as default };
//# sourceMappingURL=cascader-panel.js.map
